import UserManagement from "@/components/admin/UserManagement";

const DistrictOfficerManagement = () => {
  return <UserManagement roleList="district" />;
};

export default DistrictOfficerManagement;
